// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_BWj","cls2":"CiterightMiniReport-cls2_zBx CiterightMiniReport-cls1_BWj"};